<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      锦龙站<br>
站点介绍<br>
锦龙站位于坪山区坪山大道与荣昌路、体育二路交 叉口,车站主体沿坪山大道呈东西走向布置，东接坪山围 站，西接宝龙站。 锦龙站色彩基调以树干暖色调为主，以“阳光+”生 长为主题，体现14号线绿意盎然的生态特色主题空间。 车站为地下二层结构，地下一层为站厅层，地下二层为 站台层，站台形式为岛式站台。车站设置有5个出入口， 临近坪山创新广场，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:09	23:14	14号线	4分30秒	6分15秒<br>
沙田	06:41	00:11	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:14	23:14	14号线	5分25秒	6分15秒<br>
沙田	06:41	00:11	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:14	00:14	14号线	5分钟	6分15秒<br>
沙田	06:41	01:11	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出入口:<br>
坪山大道南侧（西）、坪山区中山中学<br><br>
B出入口:<br>
坪山大道南侧（东）、果园贝·鼎盛大厦、牛角龙小区<br><br>
C1出入口:<br>
坪山大道北侧（东）<br><br>
C2出入口:<br>
坪山大道北侧（东）<br><br>
D出入口:<br>
坪山大道北侧（西）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山城市候机楼<br>
M220、 M294、M295、M325、M326、M439、M447、M480、M546、高峰专线8、高峰专线64，牛角龙居民小组<br><br>
C1出入口:<br>
公交站名： 深业东城上邸<br>
941、E22、M220、 M294、M295、M325、366、M326、M439、M546、高峰专线8、高峰专线64<br><br>
D出入口:<br>
公交站名： 坪山城市候机楼<br>
366、833、941、A5、 B678、E17、E20、M220、 M294、M295、M325、M326、M439、M447、M368、M480、高峰专线8、高峰专线64<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>